<template>
    <v-dialog v-model="dialog" max-width="1000" scrollable @click:outside="closeDialog">
        <v-card>
            <v-card-title>
                {{ machineData.name }}
                <v-spacer />
                <v-btn icon dark @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pa-0">
                <v-tabs v-model="tab">
                    <v-tab>
                        Konfiguracja wydajności dla druku cyfrowego (rolka)
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <div class="pa-5">
                            <v-row>
                                <v-col cols="12">
                                    <v-card>
                                        <v-data-table
                                            :headers="digitalRollHeaders"
                                            :items="configurationDigitalRoll"
                                            :mobile-breakpoint="0"
                                            :items-per-page="-1"
                                            item-key="uniqueKey"
                                            hide-default-footer
                                        >
                                            <template #item.paperId="{item}">
                                                <div class="pa-2">
                                                    <v-select
                                                        v-model="item.paperId"
                                                        :items="papersWithNone"
                                                        item-value="id"
                                                        item-text="name"
                                                        dense
                                                        outlined
                                                        :error-messages="getPaperDuplicateError(item)"
                                                        :error="hasPaperDuplicate(item)"
                                                        :hide-details="!hasPaperDuplicate(item)"
                                                    />
                                                </div>
                                            </template>
                                            <template #item.makeReadyDuration="{item}">
                                                <div class="pa-2">
                                                    <v-text-field
                                                        v-model.number="item.makeReadyDuration"
                                                        v-mask="'######'"
                                                        type="number"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        :hide-details="!hasPaperDuplicate(item)"
                                                    />
                                                </div>
                                            </template>
                                            <template #item.metersPerMinute="{item}">
                                                <div class="pa-2">
                                                    <v-text-field
                                                        v-model.number="item.metersPerMinute"
                                                        v-mask="'######'"
                                                        type="number"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        :hide-details="!hasPaperDuplicate(item)"
                                                    />
                                                </div>
                                            </template>
                                            <template #item.actions="{item}">
                                                <v-btn
                                                    icon
                                                    color="error"
                                                    data-sentry-label="Usuń konfigurację druku cyfrowego (rolka)"
                                                    @click="removeDigitalRollRow(item)"
                                                >
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <template #no-data>
                                                <div class="text-center py-5 grey--text">
                                                    Brak danych. Dodaj konfigurację klikając przycisk poniżej.
                                                </div>
                                            </template>
                                            <template #footer>
                                                <div class="pa-3">
                                                    <v-btn
                                                        color="secondary"
                                                        small
                                                        data-sentry-label="Dodaj kolejną konfigurację wydajności dla druku cyfrowego (rolka)"
                                                        @click="addNewDigitalRollRow"
                                                    >
                                                        <v-icon left small>
                                                            mdi-plus
                                                        </v-icon>
                                                        Dodaj kolejną konfigurację
                                                    </v-btn>
                                                </div>
                                            </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="saving"
                    @click="closeDialog"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="saving"
                    :disabled="hasValidationErrors || saving"
                    @click="saveConfiguration"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import { mask } from 'vue-the-mask'

export default {
    name: 'DigitalRollEfficiencyDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        machineData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            dialog: false,
            tab: 0,
            configurationDigitalRoll: [],
            papersList: [],
            saving: false,
            uniqueKeyCounter: 0,
            papersLoading: false,
            digitalRollHeaders: [
                {
                    text: 'Surowiec',
                    value: 'paperId',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Czas przyrządu (min.)',
                    value: 'makeReadyDuration',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Prędkość pracy (m/min.)',
                    value: 'metersPerMinute',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Usuń',
                    value: 'actions',
                    sortable: false,
                    align: 'center'
                }
            ]
        }
    },
    computed: {
        papers() {
            return this.papersList
        },
        papersWithNone() {
            const noneOption = { id: null, name: 'brak' }

            return [noneOption, ...this.papers]
        },
        hasValidationErrors() {
            for (let i = 0; i < this.configurationDigitalRoll.length; i++) {
                const item = this.configurationDigitalRoll[i]
                const duplicates = this.configurationDigitalRoll.filter(
                    (config, index) => index !== i && config.paperId === item.paperId
                )

                if (duplicates.length > 0) {
                    return true
                }
            }

            return false
        }
    },
    watch: {
        isOpen(val) {
            if (val) {
                this.loadDataAndOpen()
            } else {
                this.dialog = false
            }
        },
        dialog(val) {
            if (!val) {
                this.$emit('on-close')
            }
        }
    },
    methods: {
        async loadDataAndOpen() {
            this.papersLoading = true
            try {
                const [papersResponse, configurationsResponse] = await Promise.all([
                    this.$store.dispatch('configurations/getPapers', {
                        paginate: '',
                        query: '?isVisible=true',
                        shouldSavedInStore: false
                    }),
                    this.$store.dispatch(
                        'configurations/getDigitalRollEfficiencyConfigurations',
                        this.machineData.id
                    )
                ])
                
                this.papersList = papersResponse.data.results || []

                const configurations = configurationsResponse.data.results || []

                this.configurationDigitalRoll = configurations.map(config => ({
                    id: config.id,
                    paperId: config.paperId,
                    makeReadyDuration: config.makeReadyDuration,
                    metersPerMinute: config.metersPerMinute,
                    uniqueKey: config.id || `temp-digital-roll-${this.uniqueKeyCounter++}`
                }))
                
                this.dialog = true
                this.$emit('on-papers-loaded')
            } catch (error) {
                errorHandler(error)
                this.$emit('on-close')
            } finally {
                this.papersLoading = false
            }
        },
        addNewDigitalRollRow() {
            this.configurationDigitalRoll.push({
                paperId: null,
                makeReadyDuration: 0,
                metersPerMinute: 0,
                uniqueKey: `new-digital-roll-${this.uniqueKeyCounter++}`
            })
        },
        removeDigitalRollRow(item) {
            const index = this.configurationDigitalRoll.findIndex(configuration => configuration.uniqueKey === item.uniqueKey)

            if (index !== -1) {
                this.configurationDigitalRoll.splice(index, 1)
            }
        },
        hasPaperDuplicate(item) {
            const duplicates = this.configurationDigitalRoll.filter(
                config => config.uniqueKey !== item.uniqueKey && config.paperId === item.paperId
            )

            return duplicates.length > 0
        },
        getPaperDuplicateError(item) {
            if (this.hasPaperDuplicate(item)) {
                return ['Ten surowiec jest już wybrany w innej konfiguracji']
            }

            return []
        },
        async saveConfiguration() {
            this.saving = true

            try {
                const payload = {
                    machineId: this.machineData.id,
                    configurations: this.configurationDigitalRoll.map(config => {
                        const item = {
                            machineId: this.machineData.id,
                            paperId: config.paperId,
                            makeReadyDuration: config.makeReadyDuration,
                            metersPerMinute: config.metersPerMinute
                        }

                        // Only include id if it exists (for updates)
                        if (config.id) {
                            item.id = config.id
                        }

                        return item
                    })
                }

                await this.$store.dispatch('configurations/saveDigitalRollEfficiencyBulk', payload)

                this.$emit('on-success')
                this.closeDialog()
            } catch (error) {
                errorHandler(error)
            } finally {
                this.saving = false
            }
        },
        closeDialog() {
            this.configurationDigitalRoll = []
            this.papersList = []
            this.tab = 0
            this.dialog = false
        }
    }
}
</script>

